import { render } from "./EmployeeProfilePanel.vue?vue&type=template&id=5650823c&scoped=true"
import script from "./EmployeeProfilePanel.vue?vue&type=script&lang=js"
export * from "./EmployeeProfilePanel.vue?vue&type=script&lang=js"

import "./EmployeeProfilePanel.vue?vue&type=style&index=0&id=5650823c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5650823c"]])

export default __exports__